import api from '@/services/api/api';

export default {
  namespaced: true,
  actions: {
    async getIntroductoryResource({ commit }, params = {}) {
      try{
        const { data } = await api.get('/course/resource/introductory', {params: params});
        return data
      }catch(err){

      }
    },
  },
};
